export default "__VITE_ASSET__CnKdsFVV__"